import React from 'react';
import AppsIcon from '@mui/icons-material/Apps';
import { Color } from "../compare/Color";
import {useDispatch} from "react-redux";

const PhotoViewFilter = ({
                             getCompareImages,
                             t,
                             viewAngle,
                             filterArrayView,
                             setIsButtonClicked,
                             trackExteriorFilterButton,
                             compareGroup,
                             setIsAngleChanged,
                             trackInteriorFilterButton,
                             handleOpen
                         }) => {
    const dispatch = useDispatch();

    return (
        <React.Fragment>
                <Color primaryColor={getCompareImages[0].colors.exteriors}
                       translate={t}
                       mediaColor={getCompareImages[0].currentColor}
                       id={0}
                       interiorColor={getCompareImages[0]?.colors?.interiors}/>
                <button
                    className={
                        viewAngle === "EXTERIOR"
                            ? "btn-active btn-photo"
                            : "btn-default btn-photo"
                    }
                    onClick={
                        () => {
                            filterArrayView("Exterior");
                            setIsButtonClicked(true);
                            dispatch(setIsAngleChanged(true));
                            trackExteriorFilterButton(compareGroup);
                        }
                    }
                    id="filter-exterior">
                    {t("photo.filter.exterior")}
                </button>
                <button className={viewAngle === "INTERIOR"
                    ? "btn-active btn-photo"
                    : "btn-default btn-photo"
                }
                        onClick={
                            () => {
                                filterArrayView("Interior");
                                setIsButtonClicked(true);
                                dispatch(setIsAngleChanged(true));
                                trackInteriorFilterButton(compareGroup);
                            }
                        }
                        id={"filter-interior"}
                >
                    {t("photo.filter.interior")}
                </button>
                <button className={'btn-default btn-photo'}
                        id={"view-photo-gallery"}
                        onClick={() => handleOpen()}>
                    <AppsIcon fontSize={"small"} />
                </button>

        </React.Fragment>
    );
}

export default PhotoViewFilter;
